import React from 'react';
import LandingPage from './components/LandingPage/LandingPage';

function App() {
  return (
      <>
        <h2 style={{textAlign: "center", marginTop: "15px"}}>Ryan Jentzsch's Profile</h2>
        <LandingPage/>
      </>
  );
}

export default App;
